import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProyectosService } from '../../../services/proyectos.service';

@Component({
  selector: 'app-planta-sedapal',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './planta-sedapal.html',
  styleUrl: './planta-sedapal.css',
})
export class PlantaSedapalComponent implements OnInit {
  proyectosRecomendados: any[] = [];

  constructor(private proyectosService: ProyectosService) {}

  ngOnInit() {
    this.proyectosRecomendados = this.proyectosService.getProyectosAleatorios('/proyectos/planta-sedapal');
  }
}
